import * as React from "react";
import { IAppState } from "./App";
import { Game } from "./Game";
import { GameDifficulty, IInvestigatorInPlay, IScenarioState } from "./Scenario";
import { CustomizeDeckComponent } from "./CustomizeDeckComponent";

interface ISummaryScreenState {
    customizeDeckPlayerIndex: number;
}
export interface ISummaryScreenProps {
    onStart: (start: boolean) => void;
    appState: IAppState;
    onScenarioStateChanged: (state: IScenarioState) => void;
    hideBackButton:boolean;
}
export class SummaryScreenComponent extends React.Component<ISummaryScreenProps, ISummaryScreenState> {
    constructor(props: ISummaryScreenProps) {
        super(props);
        this.state = { customizeDeckPlayerIndex: -1 };
    }
    customizeDeckForPlayer(playerIndex: number) {
        this.setState({ customizeDeckPlayerIndex: playerIndex });
    }
    customizationDone(investigator: IInvestigatorInPlay) {
        if (investigator) {
            const ss = ({ ...this.props.appState.scenarioState });
            ss.investigators[this.state.customizeDeckPlayerIndex] = investigator;
            this.props.onScenarioStateChanged(ss);
        }
        this.setState({ customizeDeckPlayerIndex: -1 });
    }
    render() {
        try {
            if (this.state.customizeDeckPlayerIndex >= 0) {
                const investigatorInPlay = this.props.appState.scenarioState.investigators[this.state.customizeDeckPlayerIndex];
                const clone = ({ ...investigatorInPlay });
                return (<CustomizeDeckComponent investigator={clone} onDone={(inv: IInvestigatorInPlay) => {
                    this.customizationDone(inv);
                }} />);
            } else {

                var players = this.props.appState.scenarioState.investigators.map((inv, i) => {
                    return <tr key={i}><th>{`Player ${i + 1}:`}</th><td>{inv.card.name} <i className="glyphicon glyphicon-pencil action-link" onClick={() => { this.customizeDeckForPlayer(i) }} title="Customize deck"></i></td></tr>;
                });
                return (
                    <div className="container">
                        <div className="col-md-8 col-md-offset-2 p-t-90">
                            <div id="summaryScreen">
                                <div className="content-box">
                                    <h1>Campaign settings summary</h1>
                                    <table>
                                        <tbody>
                                            <tr><th>Campaign:</th>
                                                <td>{Game.getCampaign(this.props.appState.scenarioState).name}</td>
                                            </tr>
                                            <tr><th>Scenario:</th>
                                                <td>{Game.getScenario(this.props.appState.scenarioState).name}</td>
                                            </tr>
                                            <tr>
                                                <th>Difficulty:</th>
                                                <td>{GameDifficulty[this.props.appState.scenarioState.difficulty]}</td>
                                            </tr>
                                            {players}
                                        </tbody>
                                    </table>
                                    <div className="buttonRow">
                                        <div>
                                            {this.props.hideBackButton ? null : <button onClick={() => this.props.onStart(false)}>Back</button>}
                                        </div>
                                        <div><button onClick={() => this.props.onStart(true)}>Start</button></div>
                                    </div>
                                    <div className="clearfix" />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        } catch (e) {
            return (<div>Error</div>);
        }
    }
}
